// src/components/Modals/ConfirmModal.jsx
// Confirmación nativa — bottom sheet móvil · dialog desktop

import React from "react";
import { AlertCircle, CheckCircle2, AlertTriangle, Info } from "lucide-react";
import { useIsMobile } from "../../hooks/useMediaQuery";
import NativeSheet from "../ui/NativeSheet";

export default function ConfirmModal({ data, onClose }) {
  const isMobile = useIsMobile();
  const isOpen = !!data;

  if (!data) return null;

  const {
    message = "",
    onConfirm = null,
    onCancel = null,
    onlyOk = false,
    title = "Confirmação",
    type = "default",
  } = data;

  const tone = type === "danger" ? "danger" : type === "success" ? "success" : "default";

  const Icon =
    type === "success"
      ? CheckCircle2
      : type === "warning"
      ? AlertTriangle
      : type === "danger"
      ? AlertCircle
      : Info;

  const iconWrap =
    type === "success"
      ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400"
      : type === "warning"
      ? "bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400"
      : type === "danger"
      ? "bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400"
      : "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400";

  const primaryBtn =
    type === "danger"
      ? "bg-red-600 hover:bg-red-500 shadow-red-600/25"
      : type === "success"
      ? "bg-emerald-600 hover:bg-emerald-500 shadow-emerald-600/25"
      : type === "warning"
      ? "bg-amber-500 hover:bg-amber-400 shadow-amber-500/25"
      : "bg-[var(--primary-color)] hover:opacity-90 shadow-[var(--primary-color)]/25";

  const handleCancel = (e) => {
    e?.stopPropagation();
    onCancel?.();
    onClose?.();
  };

  const handleConfirm = (e) => {
    e?.stopPropagation();
    onConfirm?.();
    onClose?.();
  };

  const footer = (
    <div className={`flex gap-2 ${isMobile ? "flex-col-reverse" : onlyOk ? "justify-end" : "justify-end"}`}>
      {!onlyOk && (
        <button
          type="button"
          onClick={handleCancel}
          className={`rounded-xl font-medium border border-color text-secondary hover:bg-hover transition active:scale-[0.98] ${
            isMobile ? "w-full py-3 text-sm" : "px-4 py-2.5 text-sm"
          }`}
        >
          Cancelar
        </button>
      )}
      <button
        type="button"
        onClick={handleConfirm}
        className={`rounded-xl font-semibold text-white shadow-md transition active:scale-[0.98] ${primaryBtn} ${
          isMobile ? "w-full py-3 text-sm" : "px-4 py-2.5 text-sm"
        }`}
      >
        {onlyOk ? "OK" : "Confirmar"}
      </button>
    </div>
  );

  return (
    <NativeSheet open={isOpen} onClose={handleCancel} title={title} tone={tone} footer={footer}>
      <div className="flex gap-3 items-start">
        <div className={`w-11 h-11 rounded-2xl flex items-center justify-center flex-shrink-0 ${iconWrap}`}>
          <Icon className="w-5 h-5" />
        </div>
        <p id="confirm-modal-title" className={`text-secondary leading-relaxed ${isMobile ? "text-sm" : "text-sm md:text-base"}`}>
          {message}
        </p>
      </div>
    </NativeSheet>
  );
}
